import { Error } from "@app/shared/models/error";

export class ValidationError{
  pmValidations:Error[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/validationError.ts